module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sectionClass,
    style: (_vm.sectionOuter)
  }, [_c('div', {
    style: (_vm.sectionHeading),
    on: {
      "click": _vm.editSection
    }
  }, [_vm._v("\n        " + _vm._s(_vm.section.title) + " (" + _vm._s(_vm.componentWidth) + ")\n        "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.settings.editing = !_vm.settings.editing
      }
    }
  }, [_vm._v("create")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "section-content",
    style: (_vm.sectionContentStyle)
  }, _vm._l((_vm.section.columns), function(column, colIndex) {
    return _c('div', {
      key: colIndex,
      staticClass: "column-outer",
      style: (_vm.columnOuterStyle(column))
    }, [_c('div', {
      staticClass: "column-inner",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      style: (_vm.sectionHeading),
      on: {
        "click": function($event) {
          return _vm.editColumn(colIndex)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(column.title) + "\n                    ")]), _vm._v(" "), _c('draggable', {
      staticClass: "column-detail draggable-container",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "options": {
          animation: 350,
          group: 'elements',
          xxxhandle: '.menu-icon'
        }
      },
      on: {
        "end": _vm.afterDrag
      },
      model: {
        value: (column.elements),
        callback: function($$v) {
          _vm.$set(column, "elements", $$v)
        },
        expression: "column.elements"
      }
    }, [_vm._l((column.elements), function(element, elIndex) {
      return [_c('ControlElement', {
        key: elIndex,
        attrs: {
          "element": element,
          "settings": _vm.pageSettings
        },
        on: {
          "click": _vm.elementClicked
        }
      })]
    })], 2)], 1)])
  }), 0), _vm._v(" "), _c('portal', {
    attrs: {
      "to": "sidebar"
    }
  }, [_c('EditPanel', {
    staticClass: "pa-2",
    attrs: {
      "element": _vm.elementEditing
    },
    on: {
      "button-click": _vm.editPanelButtonClick
    }
  })], 1), _vm._v(" "), _c('ElementDialog', {
    attrs: {
      "settings": _vm.elementDialog.settings,
      "element": _vm.section
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2c158be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/builder/Section.vue
// module id = 2637
// module chunks = 1